import React from 'react';

import { Column } from '@/components/lib/components';

import { useMarketLineSelection } from '../../hooks/use-market-line-selection';
import { Event, Market } from '../../types';
import { ViewAltLinesButton } from './ViewAltLinesButton';
import { OptionGridLayout } from './option-button-grid/OptionGridLayout';

type StackedStandardMarketProps = {
    markets: Array<Market>;
    event: Event;
    testID?: string;
};

export const StackedStandardMarket = ({ markets, event, testID }: StackedStandardMarketProps) => {
    const { hasAlternateMarkets, selectedMarket, showAlternateMarkets } = useMarketLineSelection({
        eventId: event?.id,
        markets,
    });

    return (
        <Column flex={1} gap={'s16'}>
            <OptionGridLayout columns={1} event={event} market={selectedMarket} testID={testID} />
            {hasAlternateMarkets ? (
                <ViewAltLinesButton onPress={showAlternateMarkets} testID={`viewMoreButton-${testID}`} />
            ) : null}
        </Column>
    );
};
